import { useSetRecoilState } from "recoil";
import { tasksListSearchAtom } from "../miscellaneous/tasksListSearchAtom";

export const useSetTasksListSearch = () => {
  return useSetRecoilState(tasksListSearchAtom);
};
